/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TargetRefType {
  npi_at_address = 'npi_at_address',
  drug = 'drug',
  carrier = 'carrier',
  dependent = 'dependent',
  input_id = 'input_id',
  input_ids = 'input_ids',
}
